<!--  -->
<template>
  <div class="content">
    <!-- banner -->
    <div class="banner">
      <img @click="jump" src="../../assets/img/Cycle/banner.png" alt="" />
    </div>
    <!-- 四大优势 -->
    <div class="four">
      <Link text="周期购电商系统四大优势" />
      <div class="card">
        <div class="list">
          <div
            class="li"
            v-for="(item, index) in six_list"
            :key="index"
            :style="index == 0 || index == 2||index==4 ? 'margin-top:83px;' : ''"
          >
            <img :src="item.background" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 功能模块-->
    <div class="function_do">
      <div class="left_right">
        <img class="img left" src="../../assets/img/Cycle/left.png" alt="" />
        <img class="img right" src="../../assets/img/Cycle/right.png" alt="" />
      </div>
      <!-- 中间 -->
      <div class="center card">
        <div class="text_card">
          <div class="top">后台系统功能模块</div>
          <div class="list bet">
            <div
              class="li left_with"
              v-for="(item, index) in left_list"
              :key="index"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="cril">
          <Link text="功能模块" />
        </div>
        <div class="text_card">
          <div class="top">小程序功能模块</div>
          <div class="list cen">
            <div class="li right_with" v-for="(item, index) in right_list" :key="index">
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 六大功能 -->
    <div class="Six_functions card">
      <!-- 左边 -->
      <div class="ico_list margs_left">
        <div class="ioc_li">
          <img class="img_right" src="../../assets/img/Cycle/1.png" alt="" />
          <div class="text">独立的商品上架方式，支持多规格商品添加。</div>
        </div>
        <div class="ioc_li marg_left">
          <img class="img_right" src="../../assets/img/Cycle/2.png" alt="" />
          <div class="text">支持周期购与非周期购等多种类型商品的运营销售，满足用户不同的业务需求。</div>
        </div>
        <div class="ioc_li">
          <img class="img_right" src="../../assets/img/Cycle/3.png" alt="" />
          <div class="text">可灵活分期发货，支持修改收货日期、顺延发货、修改商品收货地址。</div>
        </div>
      </div>

      <div class="center">
        <div class="cril">
          <Link text="六大功能特点" />

          <img class="row" src="../../assets/img/Cycle/row.png" alt="" />
        </div>
      </div>
      <!-- 右变 -->
       <div class="ico_list margs">
        <div class="ioc_li marg_right">
          <img class="img_left" src="../../assets/img/Cycle/4.png" alt="" />
          <div class="text">完善的分销体系，为客户和商城提供海量的推广方式，快速引流。</div>
        </div>
        <div class="ioc_li marg">
          <img class="img_left" src="../../assets/img/Cycle/5.png" alt="" />
          <div class="text">支持团购、预售、优惠券等多种主流营销手段，为产品运营提供多种玩法。</div>
        </div>
        <div class="ioc_li marg_right">
          <img class="img_left" src="../../assets/img/Cycle/6.png" alt="" />
          <div class="text">支持第三方平台订单的导入，实现多平台订单销售发货管理；货物采购入库到发货出库全流程动态监控。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      six_list: [
        {
          title: "高效引流拓客",
          text: "线上+线下+社交营销玩法搭配海量推广资源，带来更多客户和产品曝光率。",
          background: require("../../assets/img/Cycle/ico1.png"),
        },
        {
          title: "商品周期配送",
          text: "支持商品周期配送方式，可灵活制定发货周期；满足不同商品类型的配送需求",
          background: require("../../assets/img/Cycle/ico2.png"),
        },
        {
          title: "快速裂变分销",
          text: "借助分销+直播玩法，分分钟推广变渠道、分销员与客户帮卖货。",
          background: require("../../assets/img/Cycle/ico3.png"),
        },
        {
          title: "精细用户管理",
          text: "让客户洞察你的服务与产品，引导客户面对面推广，高复购和转介绍面面俱到。",
          background: require("../../assets/img/Cycle/ico4.png"),
        },
        {
          title: "终端数据分析",
          text: "PC+小程序商城终端数据分析，实时监测你的商城运营状况，指导经营决策，抢占全网流量。",
          background: require("../../assets/img/Cycle/ico5.png"),
        },
      ],
      //   后台系统功能模块
      left_list: [
        {
          text: "商品管理",
        },
        {
          text: "供应商管理",
        },
        {
          text: "分销商管理",
        },
        {
          text: "订单管理",
        },
        {
          text: "库存管理",
        },
        {
          text: "采购管理",
        },
        {
          text: "优惠卷管理",
        },
        {
          text: "团购管理",
        },
        {
          text: "促销活动",
        },
        {
          text: "首页装修",
        },
        {
          text: "分销员管理",
        },
        {
          text: "业务员",
        },
        {
          text: "预付金活动",
        },
        {
          text: "报表统计",
        },
        {
          text: "权限管理",
        },
        {
          text: "提货券管理",
        },
      ],
      right_list:[
        {
          text: "首页",
        },
        {
          text: "商品列表",
        },
        {
          text: "购物车",
        },
        {
          text: "促销活动",
        },
        {
          text: "我的",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
      // 底部
   jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang='less'>
@import url(../Cycle/pc);
</style>